import React from "react";

interface Props {
    size?: number;
    color?: string;
}

export const ValueIcon = (props: Props) => {
    const size = props.size ?? 20;
    const color = props.color ?? "var(--color-purple-400)";

    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4 18V5.56802L10 2L16 5.56802V18H4Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5 7.5C10.5 7.22386 10.2761 7 10 7C9.72386 7 9.5 7.22386 9.5 7.5C9.5 7.77614 9.72386 8 10 8C10.2761 8 10.5 7.77614 10.5 7.5Z"
                fill={color}
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
